// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_y1T","cls2":"RelatedPapers-cls2_x8- RelatedPapers-cls1_y1T"};